import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  indexCounter = 0;
  static targets = [
    "standardUnit",
    "baseUnit",
    "equivalencyContent",
    "equivalencyForm"
  ];

  onChangeStandardUnit() {
    const value = this.standardUnitTarget.selectedOptions[0].text;

    this.baseUnitTargets.forEach((element) => {
      element.value = value;
    });
  }

  baseUnitTargetConnected(element) {
    element.value = this.standardUnitTarget.selectedOptions[0].text;
  }

  delete(e) {
    e.stopPropagation();
    const content = e.target.closest(".equivalencyContent");

    if (content) {
      const indexNumber = content
        .querySelector('input[name^="product[equivalencies_attributes]"')
        .name.replace(/product\[equivalencies_attributes\]\[([0-9]+).*/, "$1");
      const idField = content.parentElement.querySelector(
        `input[name^="product[equivalencies_attributes][${indexNumber}][id]`
      );

      if (idField && idField.value) {
        content.classList.add("hidden");
        const deletedField = document.createElement("input");
        deletedField.type = "hidden";
        deletedField.name = idField.name.replace("[id]", "[_destroy]");
        deletedField.value = "true";
        idField.parentElement.insertBefore(deletedField, idField);
      } else {
        content.remove();
      }
    }
  }

  equivalencyFormTargetConnected(form) {
    form
      .querySelectorAll('[name^="product[equivalencies_attributes][0]"]')
      .forEach((input) => {
        input.name = input.name.replace(
          "product[equivalencies_attributes][0]",
          `product[equivalencies_attributes][${this.indexCounter}]`
        );
        input.id = input.id.replace(
          "product_equivalencies_attributes_0",
          `product_equivalencies_attributes_${this.indexCounter}`
        );
      });
    form
      .querySelectorAll('[for^="product_equivalencies_attributes_')
      .forEach((label) => {
        label.for = input.for.replace(
          "product_equivalencies_attributes_0",
          `product_equivalencies_attributes_${this.indexCounter}`
        );
      });
    this.indexCounter += 1;
  }
}
